import { Set } from "immutable";
import fetchJSON from "lib/fetchJSON";
import { pending, rejected } from "lib/promiseMiddlewareHelpers";
import { renderingInIframe, seededShuffle } from "lib/utils";
import _ from "lodash";

const votedIds = _.get(window, "rwgps.config.rideReports.rolloutVotes", []);

// This ensures that
// 1. If a user is logged out, they will get a randomly ordered set which is
//    consistient as long as they keep using the same browser
// 2. If a logged out user logs in, the order will not change until they switch
//    browsers
// 3. A logged in user will get consistient ordering across browsers where they
//    are logged in
const getFinalistOrderSeed = () => {
  if (!renderingInIframe() && window.localStorage && window.localStorage.getItem("finalistOrderSeed")) {
    return window.localStorage.getItem("finalistOrderSeed");
  }
  if (_.get(window, "rwgps.config.currentUser.id")) {
    return window.rwgps.config.currentUser.id;
  }
  const seed = Math.random().toString(36).substr(2, 5);
  !renderingInIframe() && window.localStorage && window.localStorage.setItem("finalistOrderSeed", seed);
  return seed;
};

export const VOTE_LIMIT = 2;

const finalistIds = [2066, 1258, 1659, 1082, 1165, 1328, 1213, 2129, 2137, 2084];

const initialState = {
  weeklyWinnerIds: [964, 1137, 1165, 1237, 1517, 1687, 1817, 1860],
  wheelsetWinnerIds: [1238, 1554],
  finalistIds: seededShuffle(finalistIds, getFinalistOrderSeed()),
  grandPrizeWinnerId: 2066,
  votedIds: Set(votedIds),
};

export const VOTE_FOR_REPORT = "rolloutContest/VOTE_FOR_REPORT";

export const SWITCH_VOTE = "rolloutContest/SWITCH_VOTE";

export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case pending(VOTE_FOR_REPORT): {
      const { reportId } = action.meta;
      const votedIds = state.votedIds.add(reportId);
      return { ...state, votedIds };
    }
    case rejected(VOTE_FOR_REPORT): {
      const { reportId } = action.meta;
      const votedIds = state.votedIds.delete(reportId);
      return { ...state, votedIds };
    }
    case pending(SWITCH_VOTE): {
      const { prevId, newId } = action.meta;
      const votedIds = state.votedIds.delete(prevId).add(newId);
      return { ...state, votedIds };
    }
    case rejected(SWITCH_VOTE): {
      const { prevId, newId } = action.meta;
      const votedIds = state.votedIds.delete(newId).add(prevId);
      return { ...state, votedIds };
    }
    default:
      return state;
  }
};

export const voteForReport = (reportId) => ({
  type: VOTE_FOR_REPORT,
  meta: { reportId },
  payload: fetchJSON(`/ride_reports/${reportId}/vote.json`, null, {
    method: "POST",
  }),
});

export const switchVote = ({ prevId, newId }) => ({
  type: SWITCH_VOTE,
  meta: { prevId, newId },
  payload: fetchJSON(`/ride_reports/${prevId}/vote.json`, null, {
    method: "DELETE",
  }).then(() => fetchJSON(`/ride_reports/${newId}/vote.json`, null, { method: "POST" })),
});
